import { render } from "./AdSense.vue?vue&type=template&id=10499310&scoped=true"
import script from "./AdSense.vue?vue&type=script&lang=js"
export * from "./AdSense.vue?vue&type=script&lang=js"

import "./AdSense.vue?vue&type=style&index=0&id=10499310&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b7c0161fc3875e000d6ad7ba26fe3ce3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10499310"]])

export default __exports__